import { Screen } from "../components/Screen";

function HomePage() {
  return <Screen />;
}

export default HomePage;
